<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.track" id="track" label="追蹤狀態">
                            <div is="option" value="">全部</div>
                            <div is="option" value="true">已追蹤</div>
                            <div is="option" value="false">未追蹤</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>學號-學生姓名</th>
                            <th>追蹤日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.HealthTrackingID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.HealthTrackingID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.HealthTrackingID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="追蹤日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './healthtrackingDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'healthtracking',
        api: '/api/healthtracking/',
        components: { Detail },
        query: { track: false }
    });
</script>

<style>
</style>